var FavouritesService = (function () {
    function FavouritesService($rootScope, $window, $filter) {
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$filter = $filter;
        this.favouriteSearchResultsKey = 'favouriteSearchResults';
        this.favouriteSolutionsKey = 'favouriteSolutions';
        this.updateFavouritesFromLocalStorage();
    }
    FavouritesService.prototype.getFavourites = function () {
        this.updateFavouritesFromLocalStorage();
        return {
            searchResults: this.favouriteSearchResults,
            solutions: this.favouriteSolutions,
        };
    };
    FavouritesService.prototype.addSearchResult = function (name, pageUrl) {
        var validPageUrl = this.validatePageUrl(pageUrl);
        var filter = this.$filter('filter');
        this.updateFavouritesFromLocalStorage();
        this.favouriteSearchResults = filter(this.favouriteSearchResults, { pageUrl: '!' + validPageUrl }, true);
        this.favouriteSearchResults.push({ name: name, pageUrl: validPageUrl });
        this.updateLocalStorage();
    };
    FavouritesService.prototype.addSolution = function (name, thirdPartyDevicesNames, pageUrl, imageUrl) {
        var validPageUrl = this.validatePageUrl(pageUrl);
        var filter = this.$filter('filter');
        this.updateFavouritesFromLocalStorage();
        this.favouriteSolutions = filter(this.favouriteSolutions, { pageUrl: '!' + validPageUrl }, true);
        this.favouriteSolutions.push({
            imageUrl: imageUrl,
            name: name,
            pageUrl: validPageUrl,
            thirdPartyDevicesNames: thirdPartyDevicesNames,
        });
        this.updateLocalStorage();
    };
    FavouritesService.prototype.remove = function (pageUrl) {
        var validPageUrl = this.validatePageUrl(pageUrl);
        var filter = this.$filter('filter');
        this.updateFavouritesFromLocalStorage();
        this.favouriteSearchResults = filter(this.favouriteSearchResults, { pageUrl: '!' + validPageUrl }, true);
        this.favouriteSolutions = filter(this.favouriteSolutions, { pageUrl: '!' + validPageUrl }, true);
        this.updateLocalStorage();
    };
    FavouritesService.prototype.removeAll = function () {
        this.updateFavouritesFromLocalStorage();
        this.favouriteSearchResults = [];
        this.favouriteSolutions = [];
        this.updateLocalStorage();
    };
    FavouritesService.prototype.check = function (pageUrl) {
        var validPageUrl = this.validatePageUrl(pageUrl);
        var filter = this.$filter('filter');
        return (filter(this.favouriteSearchResults, { pageUrl: validPageUrl }, true).length > 0 ||
            filter(this.favouriteSolutions, { pageUrl: validPageUrl }, true).length > 0);
    };
    FavouritesService.prototype.getFavouriteName = function (pageUrl) {
        var validPageUrl = this.validatePageUrl(pageUrl);
        var filter = this.$filter('filter');
        var filteredSearchResults;
        var filteredFavouriteSolutions;
        if (!this.check(validPageUrl)) {
            return;
        }
        filteredSearchResults = filter(this.favouriteSearchResults, { pageUrl: validPageUrl }, true);
        filteredFavouriteSolutions = filter(this.favouriteSolutions, { pageUrl: validPageUrl }, true);
        if (filteredSearchResults.length > 0) {
            return filteredSearchResults[0].name;
        }
        if (filteredFavouriteSolutions.length > 0) {
            return filteredFavouriteSolutions[0].name;
        }
        return '';
    };
    FavouritesService.prototype.updateFavouritesFromLocalStorage = function () {
        var _this = this;
        this.favouriteSearchResults = JSON.parse(this.$window.localStorage.getItem(this.favouriteSearchResultsKey)) || [];
        this.favouriteSearchResults.forEach(function (x) {
            x.pageUrl = _this.validatePageUrl(x.pageUrl);
        });
        this.favouriteSolutions = JSON.parse(this.$window.localStorage.getItem(this.favouriteSolutionsKey)) || [];
        this.favouriteSolutions.forEach(function (x) {
            x.pageUrl = _this.validatePageUrl(x.pageUrl);
        });
    };
    FavouritesService.prototype.updateLocalStorage = function () {
        this.$rootScope.$broadcast('favourites:changed', {
            searchResults: this.favouriteSearchResults,
            solutions: this.favouriteSolutions,
        });
        this.$window.localStorage.setItem(this.favouriteSearchResultsKey, JSON.stringify(this.favouriteSearchResults));
        this.$window.localStorage.setItem(this.favouriteSolutionsKey, JSON.stringify(this.favouriteSolutions));
    };
    FavouritesService.prototype.validatePageUrl = function (pageUrl) {
        if (pageUrl === void 0) { pageUrl = ''; }
        return pageUrl[0] === '/' ? pageUrl.slice(1) : pageUrl;
    };
    FavouritesService.$inject = ['$rootScope', '$window', '$filter'];
    return FavouritesService;
}());
export { FavouritesService };
